export const TEXT_AREA_DATA_HOOK = 'text-area';
export const TEXT_AREA_ERROR_DATA_HOOK = 'text-area-error-icon';
export const LABEL_DATA_HOOK = 'text-area-label';
export const CHAR_COUNTER_DATA_HOOK = 'char-counter';
export const ERROR_ICON_DATA_HOOK = 'error-Icon';
//# sourceMappingURL=dataHooks.js.map